const angular = require('angular');
const { SurveyHelper } = require('survey-creator-core');
const app = angular.module('learn-directives');
/**
 * Defines the Track Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {Tracks} Tracks the resource defined to manage Tracks
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 */
app.directive('trackViewer', ['Application', 'Authorization', 'Analyze', 'TrackOrganization', 'ContentAuth', 'ErrorReporting', 'SurveyHelper', '$translate', function (Application, Authorization, Analyze, TrackOrganization, ContentAuth, ErrorReporting, SurveyHelper, $translate) {
  return {
    restrict: 'E',
    scope: {
      contentId: '=?',
      journeyId: '=?',
      enterTrack: '&?'
    },
    template: require('../../templates/directives/track-viewer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      self.user = Authorization.getAuthToken().user;
      self.contentId = $scope.contentId || routeParameters.id;
      if (self.contentId && self.contentId.indexOf('?')) {
        self.contentId = self.contentId.split('?')[0];
      }
      self.originalTrack = {};
      self.originalUserTrack = {};
      self.organizedTrack = {};
      self.contentDirectory = {};
      self.translations = {};
      self.hideSurvey = true;
      self.expandSurvey = false;
      self.completedDate = null;
      self.showCertificate = false;
      self.triggerRating = false;
      self.ratingTriggered = false;
      self.inJourney = !!$scope.journeyId;
      self.closeCertificate = function() {
        self.showCertificate = false;

        if (!self.ratingTriggered && self.originalTrack.rating_configuration && self.originalTrack.rating_configuration.allow_rating) {
          self.triggerRating = true;
          self.ratingTriggered = true;
        }
        // Application.navigation.goTo('/view/tracks/' + self.originalTrack._id);
      };

      self.recordSurveyView = () => {
        Analyze.record({resource: 'views'}, {content: self.track.surveys[0].survey_id, content_type: 'survey'});
      }

      self.completedSections = {};
      self.currentSection = null;

      self.setSectionCompletion = function(track, userTrack) {
        self.completedSections = {};
        if (!track || !track.sections || !track.sections.length || !userTrack) {
          return;
        }
        var completions = [].concat((userTrack.completed_articles || []), (userTrack.completed_media || []), (userTrack.completed_quizzes || []), (userTrack.completed_scorm || []), (userTrack.completed_assessments || []));

        track.sections.forEach(function(section, index) {
          if (!section || !section.courses || !section.courses.length) {
            return;
          }

          var courses = section.courses.map(function(item) {
            return item.article || item.file || item.video || item.media || item.quiz || item.scorm || item.assessment || null;
          });

          courses = courses.map(function(item) {
            return item && item._id || null;
          });

          var completed = true;

          for (var i = 0; i < courses.length; i++) {
            if (userTrack.last_viewed && courses[i] === userTrack.last_viewed) {
              self.currentSection = section.position - 1;
            }
            if (completions.indexOf(courses[i]) === -1) {
              completed = false;
            }
          }

          self.completedSections[section.position - 1] = completed;
        });
      };

      var plural = {
        'video': 'videos',
        'article': 'articles',
        'file': 'files',
        'quiz': 'quizzes',
        'assessment': 'assessments',
        'scorm': 'scorm'
      };

      self.multiLine = {
        "visibility": false,
        isMultiple: function(str){
          var testElm = document.createElement('div');
          testElm.innerHTML =  str;
          return testElm.childElementCount > 1;
        },
        getFirst: function (str) {
          var testElm = document.createElement('div');
          testElm.innerHTML =  str;
          return testElm.firstChild.outerHTML;
        },
        getRest: function (str) {
          var testElm = document.createElement('div');
          testElm.innerHTML =  str;
          testElm.removeChild(testElm.firstChild);
          return testElm.innerHTML;
        },
        attachElmHeight: function (selector) {
          var elm = document.querySelector(selector);
          elm.setAttribute('data-height',elm.clientHeight);
        },
        collapseElmHeight: function (selector) {
          var elm = document.querySelector(selector);
          elm.style.height = '24px';
        },
        toggleHeight: function(){
          var elm = document.querySelector('.track__about__details__more');
          if (self.multiLine.visibility === false) {
            elm.style.height = elm.dataset.height + 'px' ;
          } else if(self.multiLine.visibility === true) {
            elm.style.height = '24px';
          }
          self.multiLine.visibility = !self.multiLine.visibility;
        }
      };

      setTimeout(function(){
        var intCounter = 0;
        var myInterval = setInterval(function () {
          if(document.querySelector('.track__about__details__more') !== null && document.querySelector('.track__about__details__more').innerHTML.length > 0 && document.querySelector('.track__about__details__more').clientHeight > 0 ) {
            self.multiLine.attachElmHeight('.track__about__details__more');
            self.multiLine.collapseElmHeight('.track__about__details__more');
            clearInterval(myInterval);
          } else if(intCounter === 10){
            clearInterval(myInterval);
          } else {
            intCounter++;
          }
        },300);
      },100);

      self.markupReference = {
        activeTab: 'information',
        hasLearnItems: false,
        image: function() {
          if (self.originalTrack.banner_image || self.originalTrack.image) {
            var imageUrl = self.originalTrack.banner_image ? self.originalTrack.banner_image : self.originalTrack.image;
            return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
          }
          return '//placehold.it/800x550';
        },
        checkLearnItems: function() {
          if (!self.originalTrack || !self.originalTrack.learn_items || !self.originalTrack.learn_items.length) {
            return false;
          }
          for (var i = 0; i < self.originalTrack.learn_items.length; i++) {
            if (self.originalTrack.learn_items[i]) {
              return true;
            }
          }
          return false;
        },
        commentClick: function() {
          this.activeTab = 'discussion';
        }
      };

      self.creator = {
        notesAvailable: false,
        linkedin: null,
        twitter: null,
        facebook: null,
        slack: null,
        github: null,
        instagram: null,
        youtube: null,
        dribbble: null,
        setNotes: function() {
          if (!self.originalTrack.creator_notes || typeof self.originalTrack.creator_notes !== 'string') {
            return;
          }
          var status = 'closed';

          for (var i = 0; i < self.originalTrack.creator_notes.length; i++) {
            if (status === 'closed') {
              if (self.originalTrack.creator_notes[i] !== '<') {
                this.notesAvailable = true;
                return;
              }
              status = 'open';
              continue;
            }
            if (self.originalTrack.creator_notes[i] === '>') {
              status = 'closed';
            }
          }
        },
        setSocial: function() {
          var chop = function(link) {
            if (typeof link !== 'string') {
              return;
            }
            var index = link.indexOf('://');
            if (index !== -1) {
              return link.slice(index + 3);
            }
            return link;
          };

          if (self.originalTrack.creator_linkedin) {
            this.linkedin = chop(self.originalTrack.creator_linkedin);
          }
          if (self.originalTrack.creator_twitter) {
            this.twitter = chop(self.originalTrack.creator_twitter);
          }
          if (self.originalTrack.creator_facebook) {
            this.facebook = chop(self.originalTrack.creator_facebook);
          }
          if (self.originalTrack.creator_slack) {
            this.slack = chop(self.originalTrack.creator_slack);
          }
          if (self.originalTrack.creator_github) {
            this.github = chop(self.originalTrack.creator_github);
          }
          if (self.originalTrack.creator_instagram) {
            this.instagram = chop(self.originalTrack.creator_instagram);
          }
          if (self.originalTrack.creator_youtube) {
            this.youtube = chop(self.originalTrack.creator_youtube);
          }
          if (self.originalTrack.creator_dribbble) {
            this.dribbble = chop(self.originalTrack.creator_dribbble);
          }
        }
      };

      self.trackConfig = {
        type: 'track',
        xOut: null,
        progress: null,
        userProgress: {'width': '0%'},
        progression: function(data) {
          var percent = typeof data.percentComplete === 'number' ? data.percentComplete : 0;

          self.trackConfig.progress = data.percentComplete + '%';
          self.trackConfig.userProgress = {'width': self.trackConfig.progress};
          self.trackConfig['section-' + data.nextSectionIndex] = true;
        },
        setXOut: function() {
          var history = Application.navigation.history;
          if (history.length < 2 || !self.originalTrack._id) {
            return;
          }
          for (var i = history.length - 1; i > -1; i--) {
            if (!history[i]) {
              continue;
            }
            if (!new RegExp(self.originalTrack._id).test(history[i]) || new RegExp('edit').test(history[i])) {
              this.xOut = i;
              return;
            }
          }
          this.xOut = null;
        },
        coursePrepping: false,
        goToCourse: function(course) {
          if (self.trackConfig.coursePrepping) {
            return;
          }

          if (!course) {
            if (!self.organizedTrack.track || !self.organizedTrack.track[0] || !self.organizedTrack.track[0].courses[0]) {
              return;
            }
            if (self.organizedTrack.resumeLocation) {
              course = self.organizedTrack.track[self.organizedTrack.resumeLocation[0]].courses[self.organizedTrack.resumeLocation[1]];
            } else {
              // create userTrack and go to first course
              course = self.organizedTrack.track[0].courses[0];
            }
          }

          if (!course || !course.available) {
            return;
          }
          self.trackConfig.coursePrepping = true;
          if (!self.originalUserTrack._id) {
            self.loadingTrack = true;
            self.organizedTrack.createUserTrack(self.user).then(function(data) {
              if (self.inJourney) {
                $scope.enterTrack({id: course[course.type]._id});
                return;
              }
              Application.navigation.goTo('/view/tracks/' + self.originalTrack._id + '/' + plural[course.type] + '/' + course[course.type]._id);
              self.loadingTrack = false;
              self.trackConfig.coursePrepping = false;
            }).catch(function(error) {
              self.trackConfig.coursePrepping = false;
              if (error === null) {
                Application.messaging.addMessage({type: 'error', text: self.translations["trackviewer.message.error_processing"], duration: 6});
                return;
              }
              Application.messaging.addMessage({type: 'error', text: self.translations["trackviewer.message.error_creating"], duration: 6});
            });
            return;
          };

          if (self.inJourney) {
            $scope.enterTrack({id: course[course.type]._id});
            return;
          }
          // course is available and userTrack exists
          Application.navigation.goTo('/view/tracks/' + self.originalTrack._id + '/' + plural[course.type] + '/' + course[course.type]._id);
          self.trackConfig.coursePrepping = false;
        }
      };

      self.image = function () {
        if (self.originalTrack.banner_image || self.originalTrack.image) {
          var imageUrl = self.originalTrack.banner_image ? self.originalTrack.banner_image : self.originalTrack.image;
          return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
        }
        return '//placehold.it/800x550';
      };

      self.clickCertificate = function() {
        self.showCertificate = true;
      };

      self.initialize = function() {
        if (!routeParameters.id) {
          console.log('No id specified');
          Application.navigation.goToHome();
          return;
        }
        // Prod Global Instructional Tracks Redirect for Cargurus (5ca79242d9d8ba001580f7a6) - TODO: remove this for a global redirect option
        if (Authorization.getAuthToken().company._id === '5ca79242d9d8ba001580f7a6' && (routeParameters.id === '5653bc2d96c8dae34800011b' || routeParameters.id === '5696f5654ae9ed1000fdfc93')) {
          // CG Walkthrough video
          console.log('redirecting');
          Application.navigation.goTo('/view/videos/5cb6b387d94f9b0015ccf9ed');
          return;
        } else {
          console.log('not redirecting', Authorization.getAuthToken().company._id, routeParameters.id);
        }
        // Prod Global Instructional Tracks Redirect for Cargurus (5ca79242d9d8ba001580f7a6) - TODO: remove this for a global redirect option
        if (Authorization.getAuthToken().company._id === '51d5f21b2f410a020b000002' && (routeParameters.id === '5671e6f377c9615f392c7650' || routeParameters.id === '56703b4cf372fe12008b009e')) {
          // CG Walkthrough video
          console.log('redirecting');
          Application.navigation.goTo('/view/videos/5cf5738518f6af569a877fa5');
          return;
        } else {
          console.log('not redirecting', Authorization.getAuthToken().company._id, routeParameters.id);
        }
        if (!self.user._id) {
          console.log('No userid detected');
          try {
            ErrorReporting.send({
              message: 'We detected an initialization without user-id (' + self.contentId + ')',
              context: Authorization.getAuthToken().user
            });
          } catch(e) {
            console.log('Error trying to report on issue. ', e);
          }
        }
        self.loadingTrack = true;
        self.organizedTrack = new TrackOrganization.OrganizedTrack(self.contentId, self.user._id, {progressFunction: self.trackConfig.progression});

        self.organizedTrack.initialize()
        .then(async function() {
          self.originalTrack = self.organizedTrack.originalTrack;
          self.originalUserTrack = self.organizedTrack.originalUserTrack;
          self.setSectionCompletion(self.originalTrack, self.originalUserTrack);

          if (self.originalUserTrack.completed_date) {
            self.completedDate = self.originalUserTrack.completed_date;
            if (self.originalTrack.certificate && !self.originalUserTrack.viewed_certificate) {
              self.showCertificate = true;
              self.organizedTrack.viewedCertificate();
            }

            if (!self.showCertificate && !self.ratingTriggered) {
              if (self.originalTrack.rating_configuration && self.originalTrack.rating_configuration.allow_rating) {
                self.triggerRating = true;
                self.ratingTriggered = true;
              }
            }

            if (self.originalTrack.surveys?.length) {
              self.hideSurvey = await SurveyHelper.hideSurvey(self.inJourney, self.originalTrack.surveys[0].survey_id, self.originalTrack._id);
              $scope.$apply();
            }

          }
          self.trackConfig.setXOut();

          if (self.originalTrack.average_rating) {
            self.rating = Math.round(self.originalTrack.average_rating * 5) / 100;
          }
          return ContentAuth.allowView(self.originalTrack);
        }).then(function(allowed) {
          if (!allowed) {
            Application.messaging.addMessage({type: 'error', text: self.translations["trackviewer.message.error_permission"], duration: 5});
            Application.navigation.back();
            return;
          }
          Analyze.record({resource: 'views'}, {content: self.originalTrack._id, content_type: 'track'});
          Application.analyticsProvider.trackEvent('track_viewed', {content: self.originalTrack._id, content_type: 'track', title: self.originalTrack.title});
          self.creator.setNotes();
          self.creator.setSocial();
          self.markupReference.hasLearnItems = self.markupReference.checkLearnItems();
          if (routeParameters.comment) {
            self.markupReference.activeTab = 'discussion';
          }
          if (self.organizedTrack.resumeLocation && self.organizedTrack.resumeLocation[0]) {
            self.trackConfig['section-0'] = false;
            self.trackConfig['section-' + self.organizedTrack.resumeLocation[0]] = true;
          }
          var redirect = Application.storage.get('immediateTrack');
          if (redirect && self.organizedTrack.track && self.organizedTrack.track.length) {
            for (var i = 0, len = self.organizedTrack.track.length; i < len; i++) {
              if (!self.organizedTrack.track[i] || !self.organizedTrack.track[i].courses || !self.organizedTrack.track[i].courses.length) {
                continue;
              }
              var section = self.organizedTrack.track[i];
              for (var j = 0, lenj = section.courses.length; j < lenj; j++) {
                if (!section.courses[j] || !section.courses[j].type) {
                  continue;
                }

                if (section.courses[j][section.courses[j].type]._id === redirect) {
                  Application.storage.remove('immediateTrack');
                  self.trackConfig.goToCourse(section.courses[j]);
                  return;
                }
              }
            }
          }
          Application.storage.remove('immediateTrack');
          self.loadingTrack = false;
        });
      };

      $translate([
        "trackviewer.plural.videos",
        "trackviewer.plural.articles",
        "trackviewer.plural.files",
        "trackviewer.plural.quizzes",
        "trackviewer.plural.assessment",
        "trackviewer.plural.scorm",
        "trackviewer.message.error_processing",
        "trackviewer.message.error_creating",
        "trackviewer.message.error_permission"
      ]).then(function(translations){
        self.translations = translations;
        self.initialize();
      });

    }],
    controllerAs: 'viewer'
  };
}]);
